import { z } from "zod";
import { format } from "date-fns";

const optional = () => z.string().optional().or(z.literal(""));

export const soLineSchema = z.object({
  id: z.string().optional(),
  material_id: z.string().min(1, "Material required"),
  material_grade_id: optional(),
  shape_size_id: optional(),
  description: optional(),
  qty: z.coerce.number().int().min(0),
  weight: z.coerce.number().min(0),
  uom_id: optional(),
  unit_rate: z.coerce.number().min(0),
  gst_slab: z.coerce.number().min(0).max(100),
});

export const salesOrderFormSchema = z
  .object({
    client_id: z.string().min(1, "Client is required"),
    quotation_id: optional(),
    client_po_ref: optional(),
    issue_date: z.string().min(1),
    due_date: optional(),
    payment_terms: optional(),
    bill_to_text: optional(),
    ship_to_text: optional(),
    discount: z.coerce.number().min(0),
    adjustment: z.coerce.number(),
    notes: optional(),
    terms: optional(),
    lines: z.array(soLineSchema).min(1, "Add at least one line"),
  })
  .superRefine((values, ctx) => {
    values.lines.forEach((line, i) => {
      if (line.qty <= 0 && line.weight <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["lines", i, "weight"],
          message: "Enter qty or weight",
        });
      }
    });
  });

export type SoLineFormValues = z.infer<typeof soLineSchema>;
export type SalesOrderFormValues = z.infer<typeof salesOrderFormSchema>;

export function emptySoLine(): SoLineFormValues {
  return {
    material_id: "",
    material_grade_id: "",
    shape_size_id: "",
    description: "",
    qty: 0,
    weight: 0,
    uom_id: "",
    unit_rate: 0,
    gst_slab: 18,
  };
}

export const emptySalesOrderForm: SalesOrderFormValues = {
  client_id: "",
  quotation_id: "",
  client_po_ref: "",
  issue_date: format(new Date(), "yyyy-MM-dd"),
  due_date: "",
  payment_terms: "",
  bill_to_text: "",
  ship_to_text: "",
  discount: 0,
  adjustment: 0,
  notes: "",
  terms: "",
  lines: [emptySoLine()],
};
